import {useState} from "react";
import {useRouter} from "next/navigation";
import {useTranslation} from "react-i18next";
import {navMap} from "../../../../nav/navMap";
import CasesList from "./CasesList";
import {Stack, SwipeableDrawer, IconButton, Tooltip} from "@mui/material";
import {AddOutlined, LibraryBooksOutlined} from "@mui/icons-material";


export default function CasesDrawer() {
    const router = useRouter();
    const [open, setOpen] = useState(false);
    const {t, i18n} = useTranslation();
    const currentLocale = i18n.language;

    const navToNewCaseCreator = () => {
        router.push(navMap.locale(currentLocale).newCase());
        setOpen(false);
    };

    return (
        <>
            <Stack direction='row'>
                <Tooltip title={t('common:cases.change-case')}><IconButton onClick={() => setOpen(true)}><LibraryBooksOutlined /></IconButton></Tooltip>
                <Tooltip title={t('common:cases.new-case')}><IconButton onClick={navToNewCaseCreator}><AddOutlined /></IconButton></Tooltip>
            </Stack>
            <SwipeableDrawer 
                open={open} 
                onOpen={() => setOpen(true)} 
                onClose={() => setOpen(false)} 
                PaperProps={{
                    sx: {
                    backgroundColor: 'primary.main',
                    backgroundImage: 'none',
                    },
                }}
            >
                <Stack spacing={4}
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                        height: '100%',
                        backgroundColor: 'primary.main',
                    }}>
                    <CasesList setOpen={setOpen} />
                </Stack>
            </SwipeableDrawer>
        </>
    );
}
